import React from 'react'
import cx from 'classnames'
import styles from './ModalViewFormSuccess.module.scss'
import { ButtonGroup, DynamicIcon, Heading, Paragraph } from '~elements'
import { ButtonProps, ModalViewFormSuccessProps } from '~types'
import { useWindowSize } from '~utils/hooks'

const ModalViewFormSuccess = ({
  ctas,
  description,
  handleModalClose,
  iconName = 'celebration',
  isBelowSm,
  isErrorView = false,
  title
}: ModalViewFormSuccessProps) => {
  const { isBreakpoint: isBelowMd } = useWindowSize('md', '<')

  // Add Modal close handler to error view button.
  const updatedCtas: ButtonProps[] =
    ctas?.map(cta => ({
      ...cta,
      ...(isErrorView &&
        handleModalClose && {
          onClick: () => handleModalClose()
        })
    })) || []

  return (
    <div
      className={cx(styles['view'], {
        [styles['view--error']]: isErrorView
      })}
    >
      <div className={styles['icon-wrapper']}>
        <DynamicIcon name={iconName} />
      </div>
      <Heading level={3} justify='center' noMarginTop>
        {title}
      </Heading>
      <Paragraph text={description} fontSize={isBelowSm ? 'sm' : 'md-plus'} justify='center' />
      {ctas && ctas.length > 0 && (
        <div className={styles['cta-container']}>
          <ButtonGroup
            buttons={updatedCtas}
            buttonSizeOverride='lg'
            justifyOverride='center'
            layout={isBelowMd ? 'stacked' : 'split'}
            analytics={{
              linkLocation: 'modal',
              linkModule: 'modal_form_submit',
              parentHeadline: title
            }}
          />
        </div>
      )}
    </div>
  )
}

export default ModalViewFormSuccess
